import React from "react";
import project2Img1 from "../img/project2/Screenshot 2022-06-10 at 12.18.22 PM.png";
import project2Img2 from "../img/project2/Screenshot 2022-06-10 at 12.19.26 PM.png";
import project2Img3 from "../img/project2/Screenshot 2022-06-10 at 12.20.09 PM.png";
import project2Img4 from "../img/project2/Screenshot 2022-06-10 at 12.20.38 PM.png";

const Project2 = () => {
  return (
    <div className="hero min-h-screen bg-gradient-to-r from-slate-200 to-red-200">
      <div className="hero-content text-center">
        <div className="card w-full glass shadow-xl">
          <div className="card-body">
            <div className="flex flex-col lg:flex-row gap-5">
              <div className="lg:w-1/4 rounded-full">
                <img className="" src={project2Img1} alt="" />
              </div>
              <div className="lg:w-1/4 rounded-full">
                <img className="" src={project2Img2} alt="" />
              </div>
              <div className="lg:w-1/4 rounded-full">
                <img className="" src={project2Img3} alt="" />
              </div>
              <div className="lg:w-1/4 rounded-full">
                <img className="" src={project2Img4} alt="" />
              </div>
            </div>

            <div>
              <h1 className="text-left m-3 text-slate-500">Skilled Used</h1>
              <div className="flex gap-3 mt-5">
                <p className="border rounded-lg bg-slate-200 p-1">React.js</p>
                <p className="border rounded-lg bg-slate-200 p-1">Firebase</p>
                <p className="border rounded-lg bg-slate-200 p-1">MongoDb</p>
              </div>
              <div className="text-left">
                <h1 className="text-3xl text-left mt-5 font-bold">
                  Warehouse web app
                </h1>
                <ul>
                  <li>• Implement Email and Google login (Firebase)</li>
                  <li>
                    • User can add products, remove products, and update
                    products to the warehouse
                  </li>
                  <li>• Stock management</li>
                  <li>• Customer can buy product</li>
                  <li>• Customer can give review</li>
                </ul>
              </div>

              <div className="flex gap-3">
                <a
                  href="https://warehouse-management-2b449.web.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="border rounded-xl bg-zinc-300 p-3">
                    Live website
                  </button>
                </a>
                <a
                  href="https://github.com/alnomancs/warehouse-management-client-side-alnomancs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="border rounded-xl bg-zinc-300 p-3">
                    Github Client side
                  </button>
                </a>
                <a
                  href="https://github.com/alnomancs/warehouse-management-server-side-alnomancs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="border rounded-xl bg-zinc-300 p-3">
                    Github Server side
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project2;
